<loader *ngIf="loading"></loader>

<!-- Waybills Table Section -->

<div class="delivery-data">
  <h2 class="c1">{{ "translate.delivery.title" | translate }}</h2>

  <section class="delivery-wb-actions">
    <div class="delivery-wb-row l-align-y l-align-spaceBetween">
      <div class="delivery-wb-input-row l-align-y">
        <input-wrap cssClass="delivery-wb-input-wrap">
          <input
            class="t-input"
            type="text"
            [(ngModel)]="manualOrderInput"
            [placeholder]="'translate.delivery.scanPlaceholder' | translate"
            (keydown.enter)="$event.preventDefault(); addManualOrder()"
          />
        </input-wrap>
        <button
          type="button"
          class="t-button t-button--pill t-button--success"
          (click)="addManualOrder()"
        >
          <i class="fas fa-chevron-left"></i>
        </button>
      </div>

      <input-wrap
        [loading]="(deliverersList$ | async) && (deliverersList$ | async).loading"
      >
        <p-select
          [options]="deliverersList$ | async"
          optionLabel="label"
          [(ngModel)]="selectedDeliverer"
          [resetFilterOnHide]="true"
          [filter]="true"
          [filterBy]="'label'"
          [filterPlaceholder]="'translate.general.search' | translate"
          [placeholder]="'translate.general.deliverer' | translate"
          name="selectedDeliverer"
        >
        </p-select>
        <clear-multi
          *ngIf="selectedDeliverer"
          (click)="selectedDeliverer = null"
        ></clear-multi>
      </input-wrap>

      <button
        type="button"
        class="t-button t-button--success"
        (click)="onPrint()"
        [disabled]="printing"
      >
        {{ "translate.delivery.print" | translate }}
      </button>

      <button
        class="t-button-outline t-button--pill c-c1"
        (click)="loadData(true)"
      >
        <i class="fas fa-sync-alt"></i>
      </button>
    </div>
    <div *ngIf="manualOrders.length > 0" class="delivery-wb-chips l-align-y">
      <span
        *ngFor="let orderId of manualOrders; let i = index"
        class="delivery-wb-chip"
      >
        {{ orderId }}
        <button
          type="button"
          class="delivery-wb-chip-remove t-button t-button--pill"
          aria-label="Remove"
          (click)="removeManualOrder(i)"
        >
          <i class="fas fa-times"></i>
        </button>
      </span>
    </div>
  </section>

  <ui-table
    #waybillsTable
    *ngIf="waybills && waybills.length > 0"
    [isWrapped]="false"
    [data]="waybills"
    [tblColor]="true"
    [dense]="false"
    [tblRoundBottom]="true"
    [rowId]="'orderId'"
    [numberOfRows]="numberOfRows"
    [totalRecords]="searchMetaData.totalRecords"
    (requestUpdate)="loadDataOnPagination($event)"
    [paginatorPosition]="'bottom'"
    [displayFilter]="[
            'clinicDescr',
            'orderIdMmd',
            'patientName',
            'delivererCode'
    ]"
    [templates]="[
      
      {
        title: 'translate.delivery.printedStatusLabel',
        template: printedStatus
      }
    ]"
    [rowHover]="false"
    [allowClickableRow]="false"
  ></ui-table>
</div>

<div
  *ngIf="waybills && waybills.length === 0 && !loading"
  class="t-alert-info"
  role="alert"
>
  {{ "translate.alert.noResults" | translate }}
</div>

<ng-template #printedStatus let-row="row">
  <span
    *ngIf="row?.printedStatus"
    [ngClass]="{
      'c1': row?.printedStatus === 'ALL',
      'c-warn': row?.printedStatus === 'NO',
      'c-grey-med': row?.printedStatus === 'PARTIAL',
      'fw-semibold': true
    }"
  >
    {{ ('translate.delivery.printedStatus.' + row?.printedStatus) | translate }}
  </span>
</ng-template>
